/**
 * Derivation utilities for the governance admin data layer (R1 refactor).
 *
 * These pure functions transform a PipelineBatchResult + UnifiedQuestionRow[]
 * into the various view-models the Overzicht/Vragen tabs render. Each one is
 * deterministic, side-effect-free and individually testable.
 *
 * `useGovernanceData` is now a thin composition layer over these functions.
 */
export { resolveModuleCode } from './resolveModuleCode'
export { buildUnifiedRows } from './buildUnifiedRows'
export type { UnifiedQuestionRow } from './buildUnifiedRows'
export { computeGovernanceStats } from './computeGovernanceStats'
export type { GovernanceStats } from './computeGovernanceStats'
export { computeModuleAndFamilyHealth } from './computeModuleAndFamilyHealth'
export type {
  ModuleHealth,
  FamilyHealth,
  ModuleAndFamilyHealthResult,
} from './computeModuleAndFamilyHealth'
export { selectTopBlockers } from './selectTopBlockers'
export { computeFamilyTriage } from './computeFamilyTriage'
export type { FamilyTriageItem } from './computeFamilyTriage'
